import { render } from "./edit.vue?vue&type=template&id=ada7479c"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/operation/person/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ada7479c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ada7479c', __exports__)) {
    console.log('reload')
    api.reload('ada7479c', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=ada7479c", () => {
    console.log('re-render')
    api.rerender('ada7479c', render)
  })

}


export default __exports__